const GallerySkeleton = ({ count = 9 }: { count?: number }) => (
  <section className="py-20 md:py-32 px-4">
    <div className="max-w-7xl mx-auto">
      <div className="text-center mb-16 space-y-4">
        <div className="h-12 md:h-16 w-64 md:w-96 mx-auto bg-muted/40 rounded-sm animate-pulse" />
        <div className="h-5 w-48 mx-auto bg-muted/30 rounded-sm animate-pulse" />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {Array.from({ length: count }).map((_, i) => (
          <div
            key={i}
            className="aspect-square bg-gradient-to-br from-muted/40 to-muted/20 rounded-sm animate-pulse"
            style={{ animationDelay: `${i * 60}ms` }}
          />
        ))}
      </div>
    </div>
  </section>
);

export default GallerySkeleton;
